import { render, staticRenderFns } from "./gydetail.vue?vue&type=template&id=0046c690&scoped=true"
import script from "./gydetail.vue?vue&type=script&lang=js"
export * from "./gydetail.vue?vue&type=script&lang=js"
import style0 from "./gydetail.vue?vue&type=style&index=0&id=0046c690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0046c690",
  null
  
)

export default component.exports